// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"62f857499ab9687f0b2d","488":"9d3007d8a6d5d4d0f530","532":"59f8ba85c8915f291141","592":"303afdabecfdcff5f860","736":"dde1c013071a833dfa8b"}[chunkId] + ".js";
};